/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Vietnamese (Vietnam)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description':
    'Hãy yêu cầu đội ngũ hoặc quản trị viên của bạn hỗ trợ.',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title':
    'Chúng tôi không tìm nạp được kết quả nào cho yêu cầu tìm kiếm này',
};
